export default "__VITE_ASSET__BakV0nMx__"